<template>
  <div class="container--fluid">
    <div class="row Gradient py-11 pl-6">
      <div class="col">
        <div class="row">
          <div class="col">
            <LanguageButton />
          </div>
        </div>
        <div class="row mt-5">
          <p class="Site-Survey">{{ $t('login.forgotPassword.title.label') }}</p>
        </div>
      </div>
    </div>
    <div class="row ">
      <div class="col">
        <div class="row">
          <div class="col mt-8">
            <p class="Welcome-to">
              {{ $t('login.forgotPassword.subTitle.label') }}
            </p>
          </div>
        </div>

        <div>
          <form id="loginForm" @submit="recoveryPassword">
            <div class="row">
              <div class="col--12">
                <smtt-contextual-box ref="userErrorBox" is-visible="false" :message-title="errorMessage"
                                     variation="error" dismissable="true"></smtt-contextual-box>
              </div>
            </div>
            <div class="row">
              <div class="col--12">
                <smtt-input ref="usernameInput" :error-msg="usernameErrorMsg" required type="text"
                            :label="$t('login.forgotPassword.userName.label')" full-width="true" form="loginForm"
                            @keyup.enter="recoveryPassword" @inputValueChange="usernameChanged">
                </smtt-input>
              </div>
            </div>
            <div class="row">
              <div class="col--12">
                <button type="submit" class="btn btn--primary btn--solid btn--full-width justify-content-center">
                  {{ $t('login.forgotPassword.button.label') }}
                </button>
              </div>
            </div>
            <smtt-toast ref="statusErrorToast" id="errorToast"></smtt-toast>
          </form>
        </div>

      </div>
    </div>
    <div class="row mt-11">
      <div class="col text-center">
        <img src="../../assets/images/logo-smtt.png"
             srcset="../../assets/images/logo-smtt@2x.png 2x, ../../assets/images/logo-smtt@3x.png 3x"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import LanguageButton from '../../components/login/LanguageButton';

export default {
  'name': 'ForgotPassword',
  'components': { LanguageButton },
  data() {
    return {
      'errorMessage': null,
      'username': null,
      'usernameErrorMsg': this.$t('login.username.error.message')
    }
  },
  'methods': {
    ...mapActions([
      'recoveryPasswordForUser'
    ]),
    recoveryPassword(e) {
      e.preventDefault()
      if (this.validateForm()) {
        this.recoveryPasswordForUser({ 'username': this.username }).then((response) => {
          if (!response.success) {
            this.$refs.userErrorBox.isVisible = true
            this.errorMessage = this.$t(response.message.code, response.message.params)
          } else {
            this.$router.push({ 'name': 'Login', 'params': { 'emailSuccess': true } })
          }
        }).catch((error) => {
          const toastElement = this.$refs.statusErrorToast;
          toastElement.error({
            'message': error.response.message != null ? this.$t(error.response.message.code, error.response.message.params) : this.$t('error.default.connection.message'),
            'header': this.$t('error.default.connection.title'),
            'duration': 5000
          });
        })
      }
    },
    'validateForm': function () {
      const usernameIsValid = this.$refs.usernameInput.checkValidity()
      this.$refs.usernameInput.isInvalid = !usernameIsValid
      return usernameIsValid
    },
    'usernameChanged': function (e) {
      this.username = e.detail.value
    }
  }
}
</script>

<style scoped>
  .Gradient {
    background-blend-mode: multiply;
    background-image: radial-gradient(circle at 51% -13%, #00afdb, #2d0d83 78%);
  }
  .Welcome-to {
    font-family: Roboto;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    color: #3d3d3d;
  }
  .Site-Survey {
    font-family: Roboto;
    font-size: 48px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: -0.5px;
    color: #ffffff;
  }
</style>
